<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.12 53.85">
        <title>Електронни ресурси</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path class="svg-color-1"
                      d="M21.58,31.14H12.71v2.17c0,.93.75,1.39,2.24,1.39h7.16V37h-7.9a6,6,0,0,1-3.2-.72,2.58,2.58,0,0,1-1.3-2.31v-7.7a2.77,2.77,0,0,1,1.15-2.34A5.13,5.13,0,0,1,14,23.06h8.14v2.27H14.92c-1.47,0-2.21.45-2.21,1.36v2.2h8.87Z"/>
                <path class="svg-color-1"
                      d="M58.1,20.42V17.54a.85.85,0,0,0-.94-.72H57v-.73a.63.63,0,0,0-.5-.61v-.39L54.37,13H49.74v2.46a.62.62,0,0,0-.49.61v.73H49a.85.85,0,0,0-.94.72v2.88a.94.94,0,0,0,.94.94h.7V23h6.72V21.36h.7A.94.94,0,0,0,58.1,20.42Zm-3.74-6.67,1.36,1.34H54.36Zm-4,0h3.52v1.83h2v1.33H50.37Zm5.47,8.74H50.37V19.91h5.47Zm1.48-2a.16.16,0,0,1-.16.16h-.7V19.28H49.74v1.38H49a.16.16,0,0,1-.16-.16V18.34h8.44Z"/>
                <path class="svg-color-1"
                      d="M55.83,32H53l0,0-1.1-1.61H48.63l-1.09,1.61,0,0H44.62a.44.44,0,0,0-.28.12.39.39,0,0,0-.11.28v6.25a.39.39,0,0,0,.11.28.43.43,0,0,0,.28.11H55.83a.39.39,0,0,0,.28-.11.4.4,0,0,0,.12-.28V32.38a.41.41,0,0,0-.4-.4Zm-6.49-.87a.15.15,0,0,1,0-.11.13.13,0,0,1,.1,0H51a.14.14,0,0,1,.11,0,.15.15,0,0,1,0,.11v.66a.15.15,0,0,1,0,.11.18.18,0,0,1-.11,0H49.48a.18.18,0,0,1-.1,0h0a.15.15,0,0,1,0-.11Zm2.5,6.08A2.28,2.28,0,1,1,48.62,34a2.28,2.28,0,0,1,3.22,3.22Z"/>
                <path class="svg-color-1"
                      d="M45,27.23V19.71h0l-7.25,1h0v5.89a2.46,2.46,0,0,0-1-.1A1.77,1.77,0,0,0,35,28.17a2,2,0,0,0,3.86-.38V22.64l5-.73V26a2.29,2.29,0,0,0-1-.09,1.76,1.76,0,0,0-1.78,1.69A2,2,0,0,0,45,27.23Z"/>
                <path class="svg-color-1"
                      d="M28.14,0V53.85h41V0Zm5.74,43.94H33V41.83h0V9.89L34.7,8.2H52.87l7.7,7.67V39.78a4.72,4.72,0,0,0-4.27,4.16ZM61.58,50a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,61.58,50Z"/>
                <path class="svg-color-1"
                      d="M50.23,33.8a1.78,1.78,0,0,0-1.78,1.78.18.18,0,0,0,.18.19.18.18,0,0,0,.19-.19,1.41,1.41,0,0,1,1.41-1.4.2.2,0,0,0,.19-.19A.19.19,0,0,0,50.23,33.8Z"/>
                <path class="svg-color-1"
                      d="M55.48,31.3a.35.35,0,0,0-.14-.27.62.62,0,0,0-.36-.12.59.59,0,0,0-.35.12.36.36,0,0,0-.15.27v.5h1Z"/>
                <path class="svg-color-1"
                      d="M61.58,41.27a4,4,0,1,0,4,4A4,4,0,0,0,61.58,41.27Zm0,7-3.14-3.41h2.05V42.24h2.18v2.64h2Z"/>
                <rect class="svg-color-1" x="7.44" y="50.9" width="19.67" height="2.95"/>
                <path class="svg-color-2 resource-2"
                      d="M27.1,48.63H3.83c-1.49,0-2.71-1.89-2.71-4.19V12.31c0-2.3,1.22-4.19,2.71-4.19H27.1"/>
                <circle class="svg-color-3" cx="24.34" cy="48.63" r="0.89"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "resource-icon"
    }
</script>

<style scoped>
    .resource-2 {
        fill: none;
        stroke-miterlimit: 10;
        stroke-width: 2.24px;
    }
</style>
